const ERROR_MESSAGE = 'Input is not a valid secure (https) URL';
const HTTPS_URL_PATTERN = /^https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isHttpsRule(value: any): string | true {
    return HTTPS_URL_PATTERN.test(value) || ERROR_MESSAGE;
}
